function getLastDecimalNumberUtil (number) {
  return Number.isInteger(number)
    ? number % 10
    : number.toString().slice(-1)
}

export {
  getLastDecimalNumberUtil
}
